import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/services/api.service';

@Component({
  selector: 'app-privacycomponent',
  templateUrl: './privacycomponent.component.html',
  styleUrls: ['./privacycomponent.component.css']
})
export class PrivacycomponentComponent implements OnInit {
  privacyoption;
  clicked = 'privacy';
  ref: MatDialogRef<any>;
  @Input() datatype:any;
  isPortrait:boolean = false;
  constructor(private apiservice: ApiService) {
    this.apiservice.language.subscribe((res)=>{
      this.privacyoption = res.code
    })
   }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
  }

  private checkOrientation(): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false;
  }

  
  ngOnInit() {
    this.checkOrientation();
    this.apiservice.language.subscribe((res)=>{
      this.privacyoption = res.code
    })
  }

}
